import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import { QuestionCheckInAndCheckOut } from "@/components/features/items/edit/_shared/ui/components/main/questions/check-in-and-check-out";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

import { useCheckInAndCheckOutOfHotelPolicy, useCheckInOutTimeVisibilityField } from "./hooks";

export const QuestionHotelPolicyCheckInAndCheckOut = () => {
	const { checkInStart, checkInEnd, checkOut, onSetCheckInStart, onSetCheckInEnd, onSetCheckOut } =
		useCheckInAndCheckOutOfHotelPolicy();
	const { isEdited, hasError, isShowCheckInAndCheckOut, onSetIsShowCheckInAndCheckOut } =
		useCheckInOutTimeVisibilityField();

	const guide = `チェックイン・チェックアウト時間が設定できます。<br />ここでの設定が全ての予約にデフォルトで適用されますが、プランごと個別に設定することも可能です。`;

	const showGuide = `
	チェックイン・チェックアウト時間をゲストに表示するかどうかを設定できます。<br />
	この設定は、施設の基本情報として表示されるチェックイン・チェックアウト時間のみに適用されます。<br />
	プランの個別設定によるチェックイン・チェックアウト時間の表示には影響しません。`;

	return (
		<div className="space-y-6">
			<FeatureIslandCategoryQuestionForMain
				required={false}
				title={"ゲストへの表示設定"}
				guide={showGuide}
				isEdited={isEdited}
				hasError={hasError}
				inputChildren={
					<CheckboxField
						value={isShowCheckInAndCheckOut.value}
						label={"チェックイン・チェックアウト時間をゲストに表示する"}
						handleChange={onSetIsShowCheckInAndCheckOut}
						errorMessage={isShowCheckInAndCheckOut.error}
					/>
				}
			/>
			<QuestionCheckInAndCheckOut
				checkInStart={checkInStart}
				checkInEnd={checkInEnd}
				checkOut={checkOut}
				onSetCheckInStart={onSetCheckInStart}
				onSetCheckInEnd={onSetCheckInEnd}
				onSetCheckOut={onSetCheckOut}
				guide={guide}
				isDisabled={!isShowCheckInAndCheckOut.value}
			/>
		</div>
	);
};

QuestionHotelPolicyCheckInAndCheckOut.displayName = "QuestionHotelPolicyCheckInAndCheckOut";
